import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { AD_DETAILS_API_IDS } from '~/helpers/adDetails';
import { usePricingSuggestion } from '~/hooks/usePricingSuggestion';
import { SET_SHOWN_SUGGESTED_PRICE } from '~/store/reducers/products';

const formatPrice = (price) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price);

function PricingSuggestion({ editionMode, merchantId, categoryId, brand, material, dispatch }) {
  const { isLoading, data } = usePricingSuggestion(merchantId, categoryId, brand, material);

  // Tracking mirrors the render rule: if the component would render a
  // suggestion right now (creation mode, settled response, valid number),
  // that's the value the vendor is currently looking at. Otherwise null.
  useEffect(() => {
    if (editionMode) {
      dispatch({ type: SET_SHOWN_SUGGESTED_PRICE, payload: null });
      return;
    }
    if (isLoading) return;

    const apiValue = data?.suggested_price;
    if (typeof apiValue === 'number') {
      dispatch({ type: SET_SHOWN_SUGGESTED_PRICE, payload: apiValue });
    } else {
      dispatch({ type: SET_SHOWN_SUGGESTED_PRICE, payload: null });
    }
  }, [data, isLoading, editionMode, dispatch]);

  if (editionMode) return null;
  if (isLoading || !data) return null;

  const suggestedPrice = data.suggested_price;
  if (suggestedPrice === null || suggestedPrice === undefined) return null;

  return <p className='mb-1 caption2 text-grey-medium'>Prix conseillé de vente pour un article en très bon état : {formatPrice(suggestedPrice)}</p>;
}

export default connect((state) => {
  const { form_fields } = state.products;
  const categories = form_fields[AD_DETAILS_API_IDS.CATEGORIES.CATEGORIE] || [];
  const categoryId = categories.length > 0 ? categories[categories.length - 1]?.id : null;
  const attributes = form_fields[AD_DETAILS_API_IDS.ATTRIBUTES.MAIN_KEY];

  return {
    merchantId: state.session.active_merchant?.id,
    categoryId,
    brand: attributes?.[AD_DETAILS_API_IDS.ATTRIBUTES.MARQUE],
    material: attributes?.[AD_DETAILS_API_IDS.ATTRIBUTES.MATIERE],
  };
})(PricingSuggestion);
